// extracted by mini-css-extract-plugin
export default {"title":"Notes_title__8-zzP"};